// EventPost -- the per-event message board (197).
//
// One authoritative announcement stream per event that all participants read
// (organisers post; parents read). Distinct from TeamPublication (108,
// per-team) and Conversation (140, 1:1). Append-mostly: an edit stamps
// `edited_at`, a delete is soft (`deleted_at`) and drops the post from the
// stream. Pinned posts sort to the top. No threading in v1.

export const EVENT_POST_CATEGORIES = [
  "general",
  "schedule_change",
  "logistics",
  "urgent",
] as const;
export type EventPostCategory = (typeof EVENT_POST_CATEGORIES)[number];

export interface EventPostPublic {
  id: string;
  event_id: string;
  author_id: string;
  author_role: string; // role_type captured at write time
  author_name: string; // resolved at read time -- "First Last" or email
  title: string | null;
  body: string;
  category: EventPostCategory;
  pinned: boolean;
  edited_at: string | null; // ISO timestamp; non-null once edited
  created_at: string; // ISO timestamp
  // Per-viewer capabilities -- the UI renders controls from these (ADR 003).
  _actions: {
    can_edit: boolean; // author (or an organiser) may edit/delete
    can_pin: boolean; // organisers may pin/unpin
  };
}

export interface EventPostListResponse {
  posts: EventPostPublic[];
  // Board-level capabilities: whether the viewer may post at all, and whether
  // they are an organiser (may pin) -- so the composer can show a pin control
  // even for the very first post, when no per-post _actions exist yet.
  _actions: { can_post: boolean; can_pin: boolean };
}

export interface EventPostResponse {
  post: EventPostPublic;
}
